import "../Menu.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import cakesicleFeature1 from "../../../assets/menu/cakesicles/cakesicle-feature1.jpeg";
import cakesicleFeature2 from "../../../assets/menu/cakesicles/cakesicle-feature2.jpeg";
import cakesicleFeature3 from "../../../assets/menu/cakesicles/cakesicle-feature3.jpeg";
import cakesicleFeature4 from "../../../assets/menu/cakesicles/cakesicle-feature4.jpeg";
import Accordion from "../../../common/Accordion";
import MenuNav from "../MenuNav";
import MenuGallery from "../MenuGallery";
import pricingOptions from "./quantityPricing.json";

function Cakesicles() {
  const [generalInfoOpened, setGeneralInfoOpened] = useState(false);
  const [quantityPricingOpened, setQuantityPricingOpened] = useState(false);

  return (
    <div className="wrapper">
      <h1>
        <Link to="/menu" className="menu-title-link">
          Menu
        </Link>
      </h1>
      <MenuNav />

      <MenuGallery
        image1={{ src: cakesicleFeature1, alt: "We Bare Bears cakesicles" }}
        image2={{ src: cakesicleFeature2, alt: "Unicorn cakesicles" }}
        image3={{
          src: cakesicleFeature3,
          alt: "Teal and white flower cakesicles",
        }}
        image4={{ src: cakesicleFeature4, alt: "Apple cakesicles" }}
      />

      <Accordion
        className="menu-accordion"
        title="General Information"
        isOpen={generalInfoOpened}
        onToggle={() => setGeneralInfoOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All cakesicles are{" "}
            <strong>free of tree nuts</strong>.
          </p>
          <p>
            Cakesicles (also known as cake popsicles) are cake-filled treats
            dipped in chocolate and molded into a popsicle shape, offering a
            larger surface area for creative decoration. I use premium,
            trans-fat free Eleven O'One melting chocolates in white, milk, and
            dark chocolate options.
          </p>

          <p>
            Cakesicles are individually wrapped in open cellophane bags and
            finished with a gold twist tie for a simple, elegant presentation
            perfect for party favors, gifting, or dessert displays.
          </p>

          <p>
            Cakesicles can be customized in a variety of styles – from classic
            drizzles and sprinkles to more detailed designs featuring fondant
            accents, chocolate artwork, or edible printing for logos and
            personalized designs.
          </p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Quantity & Pricing"
        isOpen={quantityPricingOpened}
        onToggle={() => setQuantityPricingOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Cakesicle flavors will come assorted based on current availability,
            though specific flavors can be accommodated with an additional
            charge. Pricing for themed cakesicles varies depending on order
            quantity and design complexity – please{" "}
            <Link to="/order">submit an order form</Link> to get a customized
            quote.
          </p>
        </div>
        {pricingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.size}</h3>
            <p>
              {option.serves}
              <br />
              {option.pricing}
            </p>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default Cakesicles;
